import './sass/main.scss';
import './js/modal.js';
import './js/scroll';
